import React, { useState, useEffect } from "react";
import styled from "@emotion/styled";
import { defaultAction } from "@actions/defaultAction";
import {
  SORT_DROP_DOWN,
  CHANGE_BUY_SEARCH_TEXT,
  SHOW_ALL_MERCHANTS,
  FILTER_BY_LETTER
} from "@constants/actionTypes";
import { getSelected } from "@modules/Buy/selector";
import "../styles/dropdown.scss";
import { useDispatch, useSelector } from "react-redux";

const InnerSpan = styled.span`
  font-size: 14px;
  font-weight: 500;
  color: #777984;
  @media (max-width: 500px) {
    display: none;
  }
`;

const DropdownContainer = styled.div`
  display: grid;
  flex-direction: row;
  align-items: center;
  grid-template-columns: 60px 1fr;
  @media (max-width: 500px) {
    grid-template-columns: 1fr;
  }
`;

const Span = styled.span`
  font-size: 14px;
  color: #1f2021;
  font-weight: 500;
  margin-right: 10px;
`;

const SelectedSpan = styled(Span)`
  @media (max-width: 500px) {
    display: none;
  }
`;

const SelectedMobileSpan = styled(Span)`
  @media (min-width: 501px) {
    display: none;
  }
  width: auto !important;
  margin-right: 10px;

  @media (max-width: 430px) {
    font-size: 13px;
  }
  @media (max-width: 400px) {
    font-size: 12px;
  }
`;

const ContainerList = styled.div`
  width: 100%;
  z-index: 2;
  cursor: pointer;
  background: white;
  border-radius: 5px;
  box-shadow: 0 5px 20px 0 rgba(38, 38, 38, 0.05);
  @media (max-width: 500px) {
    width: 141px;
    left: 0%;
  }
`;

const MainDropdown = styled.div`
  width: 100%;
  z-index: 99;
  position: relative;
  @media (max-width: 767px) {
    padding-left: 15px;
    padding-right: 15px;
    font-size: 12px;
  }
  @media (max-width: 500px) {
    padding: 0;
  }
`;

const ItemSpan = styled.span`
  white-space: pre;
  color: ${props => props.itemColor};
`;

const Dropdown = ({ newGifting }) => {
  const dispatch = useDispatch();
  const selected = useSelector(state =>
    getSelected({ selected: state.userActions.filterDropDown })
  );

  const list = [
    { name: "A - Z" },
    { name: "Most Popular" },
    { name: "Highest Discount" }
  ];
  const newBuyList = [{ name: "A - Z" }, { name: "Most Popular" }];
  const [listVisible, setListVisible] = useState(false);
  const [display, setDisplay] = useState("");
  useEffect(() => {
    if (listVisible) {
      document.addEventListener("click", hide);
    }
  }, [listVisible]);

  const resetSearch = () => {
    dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""));
    dispatch(defaultAction(SHOW_ALL_MERCHANTS));
  };

  const dropdownSearch = search => {
    dispatch(defaultAction(FILTER_BY_LETTER, search));
    dispatch(defaultAction(CHANGE_BUY_SEARCH_TEXT, ""));
  };

  const select = item => {
    setDisplay(item.name);
    dispatch(defaultAction(SORT_DROP_DOWN, item.name));
    if (item.name === "Highest Discount") {
      dropdownSearch("HIGHEST_DISCOUNT");
      ga &&
        ga(
          "send",
          "event",
          "buyMicroConversions",
          "filterSelect",
          "highestDiscount",
          { nonInteraction: true }
        );
    } else if (item.name === "Most Popular") {
      dropdownSearch("POPULARITY");
      ga &&
        ga(
          "send",
          "event",
          "buyMicroConversions",
          "filterSelect",
          "popularity",
          { nonInteraction: true }
        );
    } else if (item.name === "A - Z") {
      resetSearch();
      ga &&
        ga("send", "event", "buyMicroConversions", "filterSelect", "allCards", {
          nonInteraction: true
        });
    }
  };

  const hide = () => {
    setListVisible(false);
    document.removeEventListener("click", hide);
  };

  const arrayList = newGifting ? newBuyList : list;
  return (
    <DropdownContainer>
      <InnerSpan>Sort By</InnerSpan>
      <MainDropdown
        className={"dropdown-container" + (listVisible ? " show" : "")}
      >
        <div
          className={"dropdown-display" + (listVisible ? " clicked" : "")}
          onClick={() => {
            setListVisible(true);
          }}
        >
          <SelectedSpan>{selected}</SelectedSpan>
          <SelectedMobileSpan>{display ? selected : "Sort"}</SelectedMobileSpan>
          <i className="fa fa-angle-down" />
        </div>
        <div className="dropdown-list">
          <ContainerList>
            {arrayList.map((item, index) => (
              <div
                key={index}
                onClick={() => {
                  select(item);
                  setListVisible(false);
                }}
              >
                <ItemSpan
                  itemColor={item.name === selected ? "#ff9c1b" : "inherit"}
                >
                  {item.name}
                </ItemSpan>
                <i className="fa fa-check" />
              </div>
            ))}
          </ContainerList>
        </div>
      </MainDropdown>
    </DropdownContainer>
  );
};

export default Dropdown;
